<template>
  <div class="cotiza-container v-application">
    <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        
      >
        <v-card-text>
         <div class="loadTitle">
        <img :src="images.logo" /> <label>Cargando...</label>
        </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div
      role="alert"
      v-show="errors.length > 0"
      v-bind:class="{ show: errors.length }"
      class="alert alert-danger"
    >
      <div class="alert-text" v-for="(error, i) in errors" :key="i">
        {{ error }}
      </div>
    </div>
    <v-alert v-show="form_show" outlined :type="result_type" text>
      Gracias. Hemos recibido correctamente su solicitud.
    </v-alert>
    <section class="proyecto">
      <b-collapse class="card" animation="slide" aria-id="contentIdForA11y3">
        <template #trigger="props">
          <div
            class="card-header"
            role="button"
            aria-controls="contentIdForA11y3"
          >
            <h2 class="card-header-title" v-if="proyectSelected">
              <span class="bricsa-square"></span>Proyecto seleccionado
              <b-button @click="(proyectSelected = ''), (modelSelected = '')"
                >Seleccionar otro</b-button
              >
            </h2>
            <h2 class="card-header-title" v-else>
              <span class="bricsa-square"></span>Selecciona tu proyecto
            </h2>
            <a class="card-header-icon">
              <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"> </b-icon>
            </a>
          </div>
        </template>
        <v-progress-linear
            indeterminate
            color="green"
            v-show="projects.proyectos.length==0"
          ></v-progress-linear>
        <div class="card-content proyecto-group">
          <div
            v-for="(proy, index) in projects.proyectos"
            :key="index"
            @click="obtenerModelos(proy)"
          >
            <div
              :class="
                proyectSelected == null
                  ? ''
                  : proyectSelected.url == proy.url
                  ? 'selected'
                  : 'unselected'
              "
              class="proyecto-item"
              v-if="proy.imagen != 'https://www.bricsa.cl/wp-content/uploads/'"
            >
              <img :src="proy.imagen" />
            </div>
          </div>
        </div>
      </b-collapse>
    </section>
    <section class="modelo" v-if="proyectSelected">
      <b-collapse
        class="card"
        animation="slide"
        aria-id="contentIdForA11y3"
        v-if="proyectSelected"
      >
        <template #trigger="props">
          <div
            class="card-header"
            role="button"
            aria-controls="contentIdForA11y3"
          >
            <h2 class="card-header-title" v-if="modelSelected">
              <span class="bricsa-square"></span>Modelo seleccionado
              <b-button
                @click="
                  (modelSelected = ''),
                    (productSelected = ''),
                    (prodSelect = '')
                "
                >Seleccionar otro</b-button
              >
            </h2>
            <h2 class="card-header-title" v-else>
              <span class="bricsa-square"></span>Selecciona tu modelo
            </h2>
            <a class="card-header-icon">
              <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"> </b-icon>
            </a>
          </div>
        </template>
        <v-progress-linear
            indeterminate
            color="green"
            v-show="modelos.modelos.length==0"
          ></v-progress-linear>
        <div class="card-content modelo-group">
          <div
            class="modelo-item"
            v-for="(model, index) in modelos.modelos"
            :key="index"
            @click="obtenerDisponibilidad(model)"
            :class="
                modelSelected == null
                  ? ''
                  : model.name == modelSelected.name
                  ? 'selected'
                  : 'unselected'
              "
          >
            <img :src="model.imagen" />
            <div class="modelo-bg"></div>
            <label>{{ model.name }}</label>
          </div>
        </div>
      </b-collapse>
      <v-alert
        v-if="proyectSelected && cantidadModelos == 0"
        outlined
        type="information"
        text
      >
        No existen unidades disponibles en este proyecto.
      </v-alert>
    </section>
    <section class="productos" v-if="modelSelected">
      <b-collapse class="card" animation="slide" aria-id="contentIdForA11y3">
        <template #trigger="props">
          <div
            class="card-header"
            role="button"
            aria-controls="contentIdForA11y3"
          >
            <h2 class="card-header-title">
              <span class="bricsa-square"></span>Selecciona tu producto
            </h2>
            <a class="card-header-icon">
              <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"> </b-icon>
            </a>
          </div>
        </template>

        <div class="card-content producto-content">
          <b-field>
            <b-select
              v-model="prodSelect"
              placeholder="Elige tu producto"
              expanded
              @change="getUnidad"
            >
              <option
                v-for="prod in disponibilidad.unidades"
                :key="prod.idUnidad"
                :value="prod"
              >
                Unidad {{ prod.numero }} - Sup Terreno
                {{ prod.superficieTerreno }} - Orientación
                {{ prod.orientación }}
              </option>
            </b-select>
          </b-field>
          <div>
            <div class="producto-item" v-if="prodSelect">
              <img :src="modelSelected.imagen" />
              <div class="producto-item__info">
                <h5>{{ prodSelect.numero }}</h5>
                <h5>Desde UF {{ prodSelect.precioListaUf }}</h5>
                <h5>
                  {{ disponibilidad.dormitorios }}D -
                  {{ disponibilidad.baños }}B
                </h5>
              </div>
              <div class="producto-item__btn">
                <b-button @click="indexPlantas = 0" v-if="modelo_wp.planta">Plantas</b-button>
                <b-button @click="indexGalerias = 0" v-if="modelo_wp.galeria">Fotos</b-button
                ><b-button
                  v-if="modelo_wp.tour"
                   @click="catVirtual = true"
                  >360°</b-button
                >
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
      <b-modal v-model="catVirtual" width="100%" scroll="keep">
        <div class="card">
          <div class="card-content">
            <iframe
              style="width: 100%; height: 500px"
              class="embed-responsive-item"
              :src="modelo_wp.tour"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </b-modal>
      <Tinybox v-model="indexGalerias" :images="modelo_wp.galeria"></Tinybox>
      <Tinybox v-model="indexPlantas" :images="modelo_wp.planta"></Tinybox>

      <div class="carousel-proyect" v-if="modelo_wp.galeria">
        <font-awesome-icon
          class="carrusel-icon"
          :icon="['fa', 'chevron-right']"
        />
        <b-carousel-list
          v-model="values"
          :data="modelo_wp.galeria"
          :arrow="arrow"
          :arrow-hover="arrowHover"
          :items-to-show="perList"
          :items-to-list="increment"
          :repeat="repeat"
          :has-drag="drag"
          :has-grayscale="gray"
          :has-opacity="opacity"
        />
      </div>
      <div class="cotiza-buttons">
        <b-button
          ref="kt_login_signin_submit"
          @click="onSubmit"
          :disabled="typeof prodSelect.numero == 'undefined'"
          class="btn btn-primary align-self-center"
          >COTIZAR </b-button
        >
      </div>
    </section>
    <section class="texto-legal">
      <div class="texto-legal__info">
        <p>
          Las imágenes representadas son de carácter referencial, por lo que
          podrían no representar el resultado final del proyecto, haciendo
          presente que el mobiliario, equipamiento y paisajismo de las áreas y
          espacios comunes que se aprecian en las imágenes, no corresponden
          necesariamente a aquel que se implementará en el proyecto, lo anterior
          se informa en virtud de lo señalado en la Ley 19.472 y 19.496.
          <br /><br />
          Valor UF hasta agotar Stock, según fecha de publicación.
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Tinybox from "vue-tinybox";
import moment from "moment";
import {
  GET_PROJECTOS_WP,
  GET_MODELOS_WP,
  GET_MODELO_WP,
  CREATE_COTIZACION,
} from "@/core/services/store/proyecto.module";
import {
  GET_MODELO,
  GET_DISPONIBILIDAD,
} from "@/core/services/store/modelo.module";

export default {
  components: { Tinybox },
  data() {
    return {
      images: {
                family: process.env.BASE_URL + 'media/family.jpg',
                logo: process.env.BASE_URL +'media/logo.png',
            },
      loading: true,
      catVirtual: false,
      isLoading: false,
      form_show: false,
      result_type: "success",
      indexGalerias: -1,
      indexPlantas: -1,
      unidad: null,
      proyectSelected: null,
      modelSelected: "",
      productSelected: "",
      arrow: false,
      arrowHover: true,
      drag: true,
      gray: false,
      opacity: false,
      values: 0,
      perList: 3,
      increment: 1,
      repeat: true,
      prodSelect: {},
    };
  },
  mounted() {
    this.getProjects();
  },
  filters: {
    formatDate(value) {
      const duration = moment(value).format("DD/MM/yyyy");
      return `${duration}`;
    },

    formatTime(value) {
      const hora = moment(value).format("HH:mm:ss");
      return `${hora}`;
    },
  },
  methods: {
    info(value) {
      this.test = value;
    },
    abrir360(archivo) {
      this.loading=true;
      var blob = new Blob([this.document], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute('href', url)
      link.href = archivo;
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    getProjects() {
      this.$Progress.start();
      this.projects.proyectos=[];
      this.$store.dispatch(GET_PROJECTOS_WP, null).then(() => {
        this.$Progress.finish();
        this.loading = false;
      });
    },

    getUnidad() {
      this.unidad = this.prodSelect;
    },
    obtenerModelos(proy) {
      this.proyectSelected = proy;
      this.$Progress.start();
      this.modelos.modelos=[];
      this.$store.dispatch(GET_MODELOS_WP, proy.url).then(() => {
        this.$Progress.finish();
      });
    },
    obtenerModelo(modelo) {
      this.$Progress.start();

      this.$store.dispatch(GET_MODELO, modelo.sci).then(() => {
        this.$Progress.finish();
      });
    },
    getModeloWp() {
      this.$Progress.start();
      this.$store.dispatch(GET_MODELO_WP, this.modelSelected.sci).then(() => {
        this.$Progress.finish();
      });
    },
    obtenerDisponibilidad(modelo) {
      this.modelSelected = modelo;
      this.prodSelect = {};
      this.getModeloWp();
      this.$Progress.start();
      this.$store.dispatch(GET_DISPONIBILIDAD, modelo.sci).then(() => {
        this.$Progress.finish();
      });
    },
    onSubmit() {
      const codigoProyecto = this.proyectSelected.sci;
      const proyecto = this.proyectSelected.name;
      const codigoModelo = this.modelSelected.sci;
      const modelo = this.modelSelected.name;
      const unidad = this.prodSelect.numero;
      // set spinner to submit button
      //  const submitButton = this.$refs["kt_login_signin_submit"];
      // submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      const t = this;
      // dummy delay
      setTimeout(() => {
        // send login request
        this.$store
          .dispatch(CREATE_COTIZACION, {
            codigoProyecto,
            proyecto,
            codigoModelo,
            modelo,
            unidad,
          })
          // go to which page after successfully login
          .then(() => {
            setTimeout(() => {
              window.scrollTo(50, 0);
            }, 100);
            if(t.errors.length==0){    
              this.form_show = true;
            }
          });
      }, 500);
    },
  },
  computed: {
    ...mapState({
      errors: (state) => state.proyecto.errors,
      projects: (state) => state.proyecto.projectos_wp,
      modelos: (state) => state.proyecto.modelos_wp,
      modelo: (state) => state.modelo.modelo,
      modelo_wp: (state) => state.proyecto.modelo_wp,
      disponibilidad: (state) => state.modelo.disponibilidad,
    }),
    cantidadModelos() {
      if (typeof this.modelos.modelos == "undefined") return 0;
      return this.modelos.modelos.length;
    },
    patenteErrors() {
      const errors = [];
      if (!this.$v.form.patente) return errors;
      !this.$v.form.patente.required && errors.push("Patente es requerido");
      !this.$v.form.patente.patenteEsValido &&
        errors.push("Patente no es válida");
      return errors;
    },
  },
};
</script>

<style lang="scss" scoped>
.texto-legal {
  margin-top: 20px;
  padding: 20px;
  background: #cbcbcb;
  .texto-legal__info {
    p {
      font-style: italic;
    }
  }
}

.card {
  display: block !important;
  .card-header {
    padding: 0;
  }
}
.container {
  padding: 3% 5%;
}
.cotiza-container {
  width: 100%;
  padding: 3% 8%;
  min-height: 100vh;
  @media screen and(max-width:1024px) {
    padding: 120px 5% 3%;
  }
}
.cotiza-buttons {
  display: flex;
  justify-content: flex-start;
  @media screen and (max-width: 1024px) {
    display: grid;
    grid-template-columns: 100%;
    row-gap: 20px;
  }
  button {
    margin-right: 10px;
    color: #fff;
    background: var(--bricsa-red);
    border-radius: 0;
    border: none;
  }
}
h2 {
  color: #707070;
  font-size: 20px;
  font-weight: bold;
  text-align: left;
  margin: 10px;
  margin-left: 0;
  display: flex;
  align-items: baseline;
  span {
    display: block;
    width: 15px;
    height: 15px;
    margin-right: 5px;
    background: var(--bricsa-red);
  }
}
.proyecto {
  margin-bottom: 50px;
  .proyecto-title {
    button {
      background-color: transparent;
      border: none;
      color: var(--bricsa-red);
      font-weight: bold;
    }
  }
  .proyecto-group {
    padding: 3% 5%;
    display: grid;
    grid-template-columns: repeat(6, calc(95% / 6));
    justify-content: space-between;
    row-gap: 10px;
    @media screen and(max-width:426px) {
      grid-template-columns: repeat(3, 32%);
    }
    .proyecto-item {
      background-color: var(--bricsa-red);
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
    .unselected {
      opacity: 0.5;
    }
  }
}

.modelo {
  margin-bottom: 50px;
  .unselected {
    opacity: 0.5;
  }
  .modelo-title {
    button {
      background-color: transparent;
      border: none;
      color: var(--bricsa-red);
      font-weight: bold;
    }
  }
  .modelo-group {
    padding: 3% 5%;
    display: grid;
    grid-template-columns: repeat(4, 24%);
    justify-content: space-between;
    row-gap: 10px;
    @media screen and(max-width:426px) {
      grid-template-columns: repeat(3, 32%);
    }
    .modelo-item {
      height: 150px;
      display: grid;
      position: relative;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      @media screen and(max-width:426px) {
        height: 80px;
      }
      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        z-index: 1;
      }
      .modelo-bg {
        background-color: rgba(0, 0, 0, 0.3);
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        z-index: -1;
      }
      label {
        color: #fff;
        font-size: 24px;
        font-family: Roboto, sans-serif;
        font-weight: 500;
        display: flex;
        align-items: center;
        z-index: 98;
        @media screen and(max-width:426px) {
          height: 80px;
          font-size: 16px;
        }
      }
    }
  }
}
.productos {
  .producto-content {
    display: grid;
    .field {
      width: 200px;
      @media screen and(max-width:426px) {
        width: 100%;
      }
    }
    .producto-item {
      display: grid;
      width: 40%;
      margin-bottom: 10px;
      grid-template-columns: 120px auto;
      background-color: #fff;
      -webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      -moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      @media screen and(max-width:426px) {
        width: 100%;
      }
      img {
        width: 100%;
        max-width: 120px !important;
        height: 100%;
        object-fit: cover;
        grid-column: 1/2;
        grid-row: 1/3;
      }
      .producto-item__info {
        display: grid;
        row-gap: 5px;
        padding: 10px;
        h5 {
          font-size: 16px;
          font-weight: 600;
          font-family: Roboto, sans-serif;
          color: var(--bricsa-grey);
          text-align: left;
        }
      }
      .producto-item__btn {
        padding: 10px;
        display: flex;
        justify-content: space-between;
        .button {
          width: 100%;
          color: var(--bricsa-red);
          border: solid 1px var(--bricsa-red);
          border-radius: 0;
          transition: 400ms;
          &:hover {
            background-color: var(--bricsa-red);
            color: #fff;
          }
        }
      }
    }
  }
  .carousel-proyect {
    padding: 3% 5%;
    position: relative;
    .carrusel-icon {
      animation: carousel-right 500ms alternate-reverse infinite both;
      position: absolute;
      right: 80px;
      top: 45%;
      z-index: 99;
      width: 30px;
      height: 50px;
      color: var(--bricsa-red);
      @media screen and(max-width:768px) {
        height: 30px;
        right: 60px;
        top: 40%;
      }
      @media screen and(max-width:426px) {
        right: 30px;
        height: 20px;
      }
    }
    .carousel-list {
      box-shadow: none;
      .carousel-slides {
        .carousel-slide {
          .image {
            display: flex !important;
            img {
              height: 100%;
              object-fit: cover;
            }
          }
        }
      }
    }
  }
}
@keyframes carousel-right {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(10px);
  }
}
</style>